import React, { FC, memo, useContext, useEffect, useState } from "react";
import { IndicationApprovalStatus } from "../../typescript/types/data";
import { IndicationApprovalStageType } from "../../typescript/enums/data";
import Ellipsis from "../Common/Ellipsis";
import { makeStyles } from "@material-ui/styles";
import { VisibilityContext } from "../../context";
import { OverflowDetails } from "../../typescript/interfaces/data";
import { v4 as uuid } from "uuid";
import { StyledWideTooltip } from "../../utils/StyledWideTooltip";
import { orderBy } from "lodash";

const useStyles = makeStyles({
  overflow: {
    position: "absolute",
    top: "0px",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
  },
});

type IndicationTDProps = {
  indicationApprovalStatus: IndicationApprovalStatus[];
  width: number;
  overflow: OverflowDetails;
  rowId: number;
};

const IndicationTD: FC<IndicationTDProps> = memo(({ indicationApprovalStatus, width, overflow, rowId }) => {
  const classes = useStyles(width);

  const [visibilityContext] = useContext(VisibilityContext);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    visibilityContext.rowsExpanded.includes(rowId) || visibilityContext.detailPanelsOpen.includes(rowId)
      ? setIsOpen(true)
      : setIsOpen(false);
  }, [visibilityContext]);

  const tooltipContent = (indication: string, noRecentDevelopment: boolean) => {
    if (indication.at(-1) == "*") {
      return "This indication is limited to a specific patient subpopulation and/or requires co-administration with another therapy.";
    }

    if (noRecentDevelopment) {
      return "There are no recent developments for this indication. The stage reflects the last known status.";
    }

    return "";
  };

  return (
    <div className={overflow.isExpandable && !isOpen ? classes.overflow : ""}>
      {orderBy(
        indicationApprovalStatus,
        [(status) => status.stage !== "Withdrawn" && status.stage !== "Discontinued"],
        ["desc"]
      ).map(({ stage, indication, noRecentDevelopment }) => {
        if (stage !== IndicationApprovalStageType.Approved) {
          return (
            <Ellipsis
              key={uuid()}
              width={width}
              variant="body2"
              text={indication || ""}
              tooltip={tooltipContent(indication || "", noRecentDevelopment)}
            >
              <span style={{ fontStyle: noRecentDevelopment ? "italic" : "normal" }}>{indication}</span>
            </Ellipsis>
          );
        }
      })}
    </div>
  );
});

export default IndicationTD;
